import { api } from './client';
import type { ChatSummary, MessageDto, UserBriefDto } from './types';

/** Результаты глобального поиска по шапке списка чатов, сгруппированные по категориям —
 *  см. SearchService на бэкенде. */
export interface SearchResultDto {
  chats: ChatSummary[];
  messages: MessageDto[];
  files: MessageDto[];
  media: MessageDto[];
  links: MessageDto[];
  contacts: UserBriefDto[];
}

export function globalSearch(q: string, limit = 10): Promise<SearchResultDto> {
  return api(`/api/v1/search?q=${encodeURIComponent(q)}&limit=${limit}`);
}
